import { createFileRoute } from '@tanstack/react-router'
import { MailLinkFallback } from '../-components/mail-link-fallback'
import {
	buildMailLinkSeo,
	mailLinkSearchSchema
} from '../-lib/mail-link-fallback'

export const Route = createFileRoute('/(public)/change-email/confirm-new')({
	ssr: true,
	validateSearch: mailLinkSearchSchema,
	head: ({ match }) =>
		buildMailLinkSeo({
			appLanguage: match.context.appLanguage,
			flow: 'change_email_new',
			path: '/change-email/confirm-new'
		}),
	component: ConfirmNewEmailFallback
})

function ConfirmNewEmailFallback() {
	const { appLanguage } = Route.useRouteContext()
	const { token } = Route.useSearch()
	return (
		<MailLinkFallback
			appLanguage={appLanguage}
			flow='change_email_new'
			proof={token}
		/>
	)
}
